/* @flow */

export const generateRoute: Function = (_route: string, params: Array<*>) => {
  let route: string = _route;
  /* flow-disable-next-line */
  const routeParams: Array<*> | null = route.match(/:\w*/g);

  if (params.length < routeParams.length) {
    throw new Error('Number of url attributes provided does not match the expected number.');
  }

  routeParams.forEach((param: string, i: number) => {
    route = route.replace(param, params[i]);
  });

  return route;
};

export const router: Object = {
  generate: generateRoute,
};
